// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AccountConsolidationItem } from './account-consolidation-item';
import { AccountConsolidationStatus } from './account-consolidation-status';
import { ProximityUser } from './proximity-user';
import { AccountConsolidationStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountConsolidation extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK accountConsolidationStatus */
  accountConsolidationStatusId!: AccountConsolidationStatusEnum;
  /** DateTimeOffset */
  committedTs?: Date;
  /** Guid FK createdByUser */
  createdByUserId!: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** Guid FK donorAccount */
  donorAccountId!: string;
  /** String(250) */
  failureReason?: string;
  /** Guid FK recipientAccount */
  recipientAccountId!: string;
  /** Binary */
  rowVersion!: any;
  /** String */
  snapshotJson?: string;
  /** Inv FK accountConsolidationId */
  accountConsolidationItems!: AccountConsolidationItem[];
  /** FK accountConsolidationStatusId */
  accountConsolidationStatus!: AccountConsolidationStatus;
  /** FK createdByUserId */
  createdByUser!: ProximityUser;
  /** FK donorAccountId */
  donorAccount!: Account;
  /** FK recipientAccountId */
  recipientAccount!: Account;
}

